// Import the functions you need from the SDKs you need
import { initializeApp, getApps, FirebaseApp } from "firebase/app";
import { getAuth, Auth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, isSupported, Analytics } from "firebase/analytics";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
// Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCw5OMXFjRbUKxwKprwQXn3zVfRyI3Fx5c",
  authDomain: "bingo-5d932.firebaseapp.com",
  projectId: "bingo-5d932",
  storageBucket: "bingo-5d932.firebasestorage.app",
  messagingSenderId: "1086598431236",
  appId: "1:1086598431236:web:d4ff3af4a1be00919aeb51",
  measurementId: "G-2BWJ8NK9QH"
};

// Initialize Firebase
const app: FirebaseApp = !getApps().length
  ? initializeApp(firebaseConfig)
  : getApps()[0];

const auth: Auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, "us-central1");

// Configure auth settings for better mobile support
auth.useDeviceLanguage();

// Initialize Analytics (only on client-side and if supported)
let analyticsInstance: Analytics | null = null;
let analyticsInitPromise: Promise<Analytics | null> | null = null;

export const getAnalyticsSync = () => analyticsInstance;

export const initAnalytics = async (): Promise<Analytics | null> => {
  if (typeof window === "undefined") return null;
  if (analyticsInstance) return analyticsInstance;
  analyticsInitPromise ??= isSupported().then((supported) => {
    if (supported) {
      analyticsInstance = getAnalytics(app);
      return analyticsInstance;
    }
    return null;
  });
  return analyticsInitPromise;
};

// It's good practice to export the initialized app and auth services
export { app, auth, db, functions };
